import React, {useContext, useState} from 'react';
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import axios from "axios";
import {Elink, UploadInventoryOrRoomImagesUrl} from "../CommonComponents/Routes";
import {Modal} from "react-bootstrap";
import {AnimationPrevious} from "./AnimationPrevious";

const TakePicture = (props) =>{
    const [dataUri, SetDataUri] = useState('');
    const [Loader, SetLoader] = useState(false);
    const RecordController = useContext(RecordsManagementContext);
    const PageView = useContext(ViewMangementContext);
    function handleTakePhoto (dataUri) {
        // Do stuff with the photo...
        console.log('takePhoto');
    }

    function handleTakePhotoAnimationDone (dataUri) {
        // Do stuff with the photo...
        console.log('takePhoto');
        SetDataUri(dataUri);
    }

    function handleCameraError (error) { // showing error if device has not camera or dont allow camera
        RecordController.SetClick("no-class");
        if(error){
            PageView.Set("MOBILE_ROOM_DETAIL");
            PageView.setAlertProperty({
                Message: "Device doesn't have camera.",
                Type: "warning",
                Show: true,
                AutoHide: true
            })
        }
        console.log('handleCameraError', error);
    }

    function handleCameraStart (stream) {
        console.log('handleCameraStart');
    }

    function handleCameraStop () {
        console.log('handleCameraStop');
    }

    const Cancel = () =>{
        SetDataUri('');
    }

    const SaveImage = () => {// this component is used to save the clicked image
        if(RecordController.CameraFrom === "Room"){// for room
            RecordController.setCustomItemModal(true);
            SetLoader(true);
            try {
                 axios({
                    method: 'post',
                    url: UploadInventoryOrRoomImagesUrl,
                    data: {
                        room_est_id: RecordController.Room.Id,
                        estimate_key: Elink,
                        picture_type: "Room Inventory",
                        capture_image: dataUri,
                    }
                 }).then( async (response) =>{
                     await SetLoader(false);
                     await RecordController.setCustomItemModal(false);
                     RecordController.SetClick("next");
                     AnimationPrevious ( "next-go",  "take-picture-page",  "MOBILE_ROOM_DETAIL", PageView);
                 });
            } catch (error) {
                console.log(error);
            }
        }
        else if(RecordController.CameraFrom === "Custom")// for custom inventory
        {
            dataUri ? RecordController.SetCaptureImage(dataUri) : RecordController.SetCaptureImage('');
            RecordController.SetClick("next");
            AnimationPrevious ( "next-go",  "take-picture-page",  "CUSTOM_ITEM_PAGE", PageView);
        }
    }
    const handleModal = () => {
        RecordController.setCustomItemModal(false);
    }
    const ReturnToRoom=()=>{ // back to room page
        RecordController.SetClick("back");
        AnimationPrevious ( "back-go",  "take-picture-page",  "MOBILE_ROOM_DETAIL", PageView);
    }
    return (
        dataUri ?
            <>
                <div className={'card'}>
                <img className={'img-thumbnail -align-center'} src={dataUri} alt="preview image" style={{margin: "1.5%", borderRadius: "12px", height: "80vh"}}/>
                <div className={'row'}>
                    <div className="btn btn-md btn-warning col-3 camera-button" title={"Back"} onClick={()=>ReturnToRoom()}>
                        <i className="fa fa-arrow-left" aria-hidden="true"></i>
                    </div>
                    <div className="btn btn-md btn-danger col-3 camera-button" title={"Retake"} onClick={()=>Cancel()}>
                        <i className="fa fa-repeat" aria-hidden="true"></i>
                    </div>
                    <div className="btn btn-md btn-success col-3 camera-button" title={"Done"} onClick={()=>SaveImage()}>
                        <i className="fa fa-check" aria-hidden="true"></i>
                    </div>
                </div>
                </div>
                { Loader ?
                    <Modal id="mobile-link-modal" show={RecordController.CustomItemModal} onHide={() => handleModal()}>
                        <Modal.Header><h4 className="custom-item-heading">Saving Image</h4></Modal.Header>
                        <img src={process.env.PUBLIC_URL + "/Images/Loader18.gif"} style={{width: "50%", margin:"auto"}}/>
                    </Modal>
                    :
                    ''}
            </>
            :
            <>
                <div className={"card take-picture-page"}>
                    {/*add back option*/}
                    <div className="btn btn-md btn-warning col-12 camera-button" title={"Back"} onClick={()=>ReturnToRoom()}>
                        <i className="fa fa-arrow-left" aria-hidden="true"></i> Back
                    </div>
                    {/* add camera using 'react-html5-camera-photo' */}
                    <Camera
                        onTakePhoto = { (dataUri) => { handleTakePhoto(dataUri); } }
                        onTakePhotoAnimationDone = { (dataUri) => { handleTakePhotoAnimationDone(dataUri); } }
                        onCameraError = { (error) => { handleCameraError(error); } }
                        idealFacingMode = {FACING_MODES.ENVIRONMENT}
                        idealResolution = {{width: 640, height: 480}}
                        imageType = {IMAGE_TYPES.JPG}
                        imageCompression = {0.40}
                        isImageMirror = {false}
                        isSilentMode = {false}
                        isDisplayStartCameraError = {true}
                        sizeFactor = {1}
                        onCameraStart = { (stream) => { handleCameraStart(stream); } }
                        onCameraStop= { () => { handleCameraStop(); } }/>
                </div>
            </>
    );
}

export default TakePicture;